module.exports = __webpack_public_path__ + "static/media/clarity.28e0b229.jpg";